import React from 'react';
import Style from './accordion.module.css';
/** @jsxImportSource @emotion/react */

import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

const Accordion = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("ul", {
      className: `${Style.accordion}`,
      css: emotionStyle,
      children: props.children
    }), propsArray.className !== '' && _jsx("ul", {
      className: `${Style.accordion} ${propsArray.className}`,
      css: emotionStyle,
      children: props.children
    })]
  });
};

Accordion.Wrapper = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("li", {
      css: emotionStyle,
      children: props.children
    }), propsArray.className !== '' && _jsx("li", {
      className: `${propsArray.className}`,
      css: emotionStyle,
      children: props.children
    })]
  });
};

Accordion.Header = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  const toggle = event => {
    event.target.closest('li').querySelector('svg').classList.toggle(`${Style.rotate}`);

    if (event.target.closest('li').querySelector(`.${Style.body}`).offsetHeight === 0) {
      event.target.closest('li').querySelector(`.${Style.body}`).style.maxHeight = event.target.closest('li').querySelector(`.${Style.body} > div`).offsetHeight + 'px';
    } else {
      event.target.closest('li').querySelector(`.${Style.body}`).style.maxHeight = 0;
    }
  };

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsxs("div", {
      onClick: toggle,
      className: `${Style.header}`,
      css: emotionStyle,
      children: [props.children, _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 8 6",
        children: _jsx("path", {
          d: "M4 5.091a.748.748 0 0 1-.531-.219l-3.11-3.11a.5.5 0 0 1 .708-.707l2.932 2.933 2.933-2.933a.5.5 0 0 1 .707.707l-3.11 3.11a.748.748 0 0 1-.53.22Z"
        })
      })]
    }), propsArray.className !== '' && _jsxs("div", {
      onClick: toggle,
      className: `${Style.header} ${propsArray.className}`,
      css: emotionStyle,
      children: [props.children, _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 8 6",
        children: _jsx("path", {
          d: "M4 5.091a.748.748 0 0 1-.531-.219l-3.11-3.11a.5.5 0 0 1 .708-.707l2.932 2.933 2.933-2.933a.5.5 0 0 1 .707.707l-3.11 3.11a.748.748 0 0 1-.53.22Z"
        })
      })]
    })]
  });
};

Accordion.Body = props => {
  const propsArray = [];
  propsArray.className = props.className === undefined ? '' : props.className;
  propsArray.active = Style[props.active === undefined || props.active === false ? 'inactive' : 'active'];
  let emotionStyle = [];

  if (props.ms !== undefined) {
    emotionStyle = props.ms;
  }

  return _jsxs(React.Fragment, {
    children: [propsArray.className === '' && _jsx("div", {
      className: `${Style.body} ${propsArray.active}`,
      css: emotionStyle,
      children: _jsx("div", {
        children: props.children
      })
    }), propsArray.className !== '' && _jsx("div", {
      className: `${Style.body} ${propsArray.className} ${propsArray.active}`,
      css: emotionStyle,
      children: _jsx("div", {
        children: props.children
      })
    })]
  });
};

export default Accordion;